var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewDetailsArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.0001 7.99981L8.5901 7.99981L5.2901 11.2898C5.1018 11.4781 4.99601 11.7335 4.99601 11.9998C4.99601 12.2661 5.1018 12.5215 5.2901 12.7098C5.47841 12.8981 5.7338 13.0039 6.0001 13.0039C6.26641 13.0039 6.5218 12.8981 6.7101 12.7098L11.7101 7.70981C11.8011 7.61471 11.8725 7.50257 11.9201 7.37981C12.0201 7.13635 12.0201 6.86328 11.9201 6.61981C11.8725 6.49706 11.8011 6.38492 11.7101 6.28981L6.7101 1.28982C6.61714 1.19609 6.50654 1.12169 6.38468 1.07092C6.26282 1.02015 6.13212 0.994017 6.0001 0.994017C5.86809 0.994017 5.73739 1.02015 5.61553 1.07092C5.49367 1.12169 5.38307 1.19609 5.2901 1.28982C5.19638 1.38278 5.12198 1.49338 5.07121 1.61524C5.02044 1.7371 4.99431 1.8678 4.99431 1.99981C4.99431 2.13183 5.02044 2.26253 5.07121 2.38439C5.12198 2.50625 5.19638 2.61685 5.2901 2.70981L8.5901 5.99981L1.0001 5.99981C0.734887 5.99981 0.480533 6.10517 0.292996 6.29271C0.10546 6.48024 0.000103951 6.7346 0.000103951 6.99981C0.000103951 7.26503 0.10546 7.51938 0.292996 7.70692C0.480533 7.89446 0.734887 7.99981 1.0001 7.99981Z",
    fill: "#275CE6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewDetailsArrow);
export default __webpack_public_path__ + "static/media/viewDetailsArrow.e2de444e43efec029fa353677679fc0b.svg";
export { ForwardRef as ReactComponent };